<template>
  <d-container fluid class="main-content-container px-4 pb-4">
    <!-- Page Header -->
    <d-row no-gutters class="page-header py-4">
      <!-- Page Title -->
      <d-col col sm="4" class="text-center text-sm-left mb-4 mb-sm-0">
        <span class="text-uppercase page-subtitle">Tiers</span>
        <h3 class="page-title">Manage Tiers</h3>
      </d-col>
    </d-row>
    <!-- Default Light Table -->
    <div class="row">
      <div class="col">
        <div class="card card-small mb-4">
          <div class="card-header border-bottom">
            <h6 class="m-0">Tiers</h6>
          </div>
          <div class="card-body p-0 pb-3 text-center">
            <table class="table mb-0">
              <thead class="bg-light">
                <tr>
                  <th scope="col" class="border-0">#</th>
                  <th scope="col" class="border-0">Name</th>
                  <th scope="col" class="border-0">Emoji</th>
                  <th scope="col" class="border-0">Subtitle</th>
                  <th scope="col" class="border-0">Level</th>
                  <th scope="col" class="border-0">Details & Benefits</th>
                  <th scope="col" class="border-0">Actions Required</th>
                  <th scope="col" class="border-0">Actions</th>
                <!--  <th scope="col" class="border-0">Show Number of supporters</th>-->
                  <th scope="col" class="border-0">Visibility</th>
                  <th scope="col" class="border-0">Modify</th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="tiers.length > 0" v-for="(tier, index) in tiers">
                  <td>{{ index + 1 }}</td>
                  <td>{{ tier.name }}</td>
                  <td>{{ tier.emoji }}</td>
                  <td>{{ tier.subtitle }}</td>
                  <td>
                    <span class="number-label">{{ tier.level }}</span>
                  </td>
                  <td>
                    <p class="tier-description">
                      {{ tier.details_and_benefits }}
                    </p>
                  </td>
                  <td>
                    <span class="number-label">{{
                      tier.required_actions
                    }}</span>
                  </td>
                  <template v-if="tier.actions.length > 0">
                    <td>
                      <span
                        v-if="tier.actions.length > 0"
                        v-for="action in tier.actions.slice(0, 2)"
                        class="action-tag"
                        >{{ action.button_text }}</span
                      >
                    </td>
                  </template>
                  <template v-if="!tier.actions.length">
                    <td>None</td>
                  </template>

                  <td>
                    <button class="btn mb-2 mr-1 btn-success" disabled>
                      {{ tier.visibility ? "LIVE" : "DRAFT" }}
                    </button>
                  </td>
                  <td>
                    <a
                      @click.prevent="scrollToEditPanel(tier)"
                      class="ml-auto"
                      href="#"
                      ><i class="material-icons">edit</i> Edit</a
                    >
                    <a
                      @click.prevent="deleteTier(tier)"
                      class="ml-auto text-danger d-flex mt-2"
                      href="#"
                    >
                      <i class="material-icons">delete</i> Delete</a
                    >
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <d-row no-gutters class="page-header py-4">
      <!-- Page Title -->
      <d-col col sm="4" class="text-center text-sm-left mb-4 mb-sm-0">
        <span class="text-uppercase page-subtitle">Tiers</span>
        <h3 class="page-title">Add Tier</h3>
      </d-col>
    </d-row>

    <d-row>
      <!-- Editor -->
      <div class="edit col-lg-9 col-md-12" ref="editPanel">
        <d-col style="padding:0px;">
          <anp-editor
            :selectedTier="selectedTier"
            :selectedActions="selectedActions"
            :addButton="addButton"
            @addButtonClick="onAddButtonClick"
          />
        </d-col>
      </div>

      <!-- Sidebar Widgets -->
      <d-col lg="3" md="12">
        <anp-sidebar-categories
          @actionAssigned="onChildChange"
          :selectedTier="selectedTier"
          :addButton="addButton"
          @addButtonClick="onAddButtonClick"
        />
      <!--  <anp-sidebar-actions />-->
      </d-col>
    </d-row>
  </d-container>
</template>

<script>
import SidebarActions from "@/components/add-new-post/SidebarTiersDetails.vue";
import SidebarCategories from "@/components/add-new-post/SidebarCategories.vue";
import Editor from "@/components/add-new-post/Tier-Editor.vue";
import tiersTypes from "../vuex/tiers/tiers.types";

import { mapState } from "vuex";

import "quill/dist/quill.snow.css";

export default {
  data() {
    return {
      addButton: true,
      tiers: [],
      selectedTier: null,
      selectedActions: []
    };
  },
  computed: {
    ...mapState({
      state: state => state.tiers.state,
      type: state => state.tiers.type,
      data: state => state.tiers.data,
      error: state => state.tiers.error
    })
  },
  methods: {
    scrollToEditPanel(tier) {
      this.selectedTier = { actions: [] };
      this.$nextTick(function() {
        this.selectedTier = tier;
        this.addButton = false;
        this.$refs.editPanel.scrollIntoView();
      });
    },
    deleteTier(tier) {
      this.$store.dispatch("deleteTier", tier);
    },
    onAddButtonClick(addButton) {
      this.addButton = addButton;
    },
    onChildChange(selectedActionTitles) {
      this.selectedActions = selectedActionTitles;
    }
  },
  watch: {
    type(newType) {
      if (newType === tiersTypes.FETCH_TIERS_SUCCESS) {
        this.tiers = this.data.tiers;
        this.$toasted.clear();
      } else if (newType === tiersTypes.ADD_TIER_SUCCESS) {
        this.$toasted.clear();
        this.$toasted.success("Tier added", {
          position: "top-center",
          duration: 1000,
          fullWidth: false,
          keepOnHover: true,
          singleton: true,
          action: {
            text: "Close",
            onClick: (e, toastObject) => {
              toastObject.goAway(0);
            }
          }
        });
      } else if (newType === tiersTypes.UPDATE_TIER_SUCCESS) {
        this.$toasted.clear();
        this.$toasted.success("Tier Updated Successfully", {
          position: "top-center",
          duration: 1000,
          fullWidth: false,
          keepOnHover: true,
          singleton: true,
          action: {
            text: "Close",
            onClick: (e, toastObject) => {
              toastObject.goAway(0);
            }
          }
        });
      } else if (newType === tiersTypes.DELETE_TIER_SUCCESS) {
        this.$toasted.clear();
        this.$toasted.success("Tier deleted", {
          position: "top-center",
          duration: 1000,
          fullWidth: false,
          keepOnHover: true,
          singleton: true,
          action: {
            text: "Close",
            onClick: (e, toastObject) => {
              toastObject.goAway(0);
            }
          }
        });
      } else if (newType === tiersTypes.FETCH_TIERS_REQUEST) {
        this.$toasted.info("Fetching tiers...", {
          icon: "hourglass_empty",
          //duration: 1000,
          fullWidth: false,
          keepOnHover: true,
          singleton: true
          /*action: {
            text: "Close",
            onClick: (e, toastObject) => {
              toastObject.goAway(0);
            }
          }*/
        });
      } else if (newType === tiersTypes.UPDATE_TIER_REQUEST) {
        this.$toasted.info("Updating tier..", {
          icon: "hourglass_empty",
          position: "top-center",
          fullWidth: false,
          keepOnHover: true,
          singleton: true,
          action: {
            text: "Close",
            onClick: (e, toastObject) => {
              toastObject.goAway(0);
            }
          }
        });
      } else if (newType === tiersTypes.DELETE_TIER_REQUEST) {
        this.$toasted.info("Deleting tier..", {
          icon: "hourglass_empty",
          position: "top-center",
          fullWidth: false,
          keepOnHover: true,
          singleton: true,
          action: {
            text: "Close",
            onClick: (e, toastObject) => {
              toastObject.goAway(0);
            }
          }
        });
      } else if (
        newType === tiersTypes.FETCH_TIERS_FAILED ||
        newType === tiersTypes.ADD_TIER_FAILED ||
        newType === tiersTypes.UPDATE_TIER_FAILED ||
        newType === tiersTypes.DELETE_TIER_FAILED
      ) {
        this.$toasted.clear();
        this.$toasted.error(this.error, {
          icon: "error_outline",
          //duration: 1000,
          keepOnHover: true,
          singleton: true,
          action: {
            text: "Close",
            onClick: (e, toastObject) => {
              toastObject.goAway(0);
            }
          }
        });
      }
    }
  },
  created() {
    this.$store.dispatch("fetchTiers");
    this.$store.dispatch("fetchActions");
  },
  components: {
    anpEditor: Editor,
    anpSidebarActions: SidebarActions,
    anpSidebarCategories: SidebarCategories
  }
};
</script>
<style>
.action-tag {
  padding: 0.4286rem 0.875rem;
  font-size: 0.6875rem;
  line-height: 1.5;
  border-radius: 0.25rem;
  color: white;
  background-image: none;
  border-color: #495057;
  /* opacity: 0.65; */
  background-color: #495057;
  box-shadow: none;
  display: inline-block;
  margin-top: 5px;
  margin-bottom: 5px;
  margin-left: 5px;
  white-space: nowrap;
}
.number-label {
  padding: 0px;
  padding-left: 0px;
  padding-right: 0px;
  padding-top: 4px;
  background: #00b8d8;
  color: white;
  border-radius: 20px;
  display: inline-block;
  min-width: 30px;
  min-height: 30px;
  text-align: center;
}

.tier-description {
  font-size: 14px;
  max-width: 300px;
}
</style>
